<ion-modal
  #skinPromptModal
  id="skin-prompt-modal"
  [backdropDismiss]="false"
  [breakpoints]="[0, 1]"
  [handle]="false"
  [initialBreakpoint]="1"
  [isOpen]="isOpen()"
  (didDismiss)="onDidDismissModal()"
  (didPresent)="onDidPresentModal()"
  (willDismiss)="onWillDismissModal()"
>
  <ng-template>
    <div class="content">
      <div class="content__header">
        <ion-button fill="clear" (click)="skinPromptModal.dismiss()">
          <ion-icon name="chevron-down-outline"></ion-icon>
        </ion-button>
      </div>
      <h1 class="content__title">Begin Your Face Scan with Asa Illumination</h1>
      <div class="content__disclaimer">
        <div class="size-2 rounded-full bg-[#9766B8]"></div>
        <span class="text-caption font-normal text-dark"
          >Powered by Asa Illumination</span
        >
        <svg
          class="cursor-pointer active:scale-95"
          fill="none"
          viewBox="0 0 12 12"
          width="12"
          xmlns="http://www.w3.org/2000/svg"
          (click)="modal.disclaimer = true"
        >
          <g clip-path="url(#clip0-1115-6060)">
            <path
              d="M6 0C2.68352 0 0 2.68376 0 6C0 9.31648 2.68376 12 6 12C9.31648 12 12 9.31624 12 6C12 2.68352 9.31622 0 6 0ZM6 11.0625C3.20173 11.0625 0.9375 8.79809 0.9375 6C0.9375 3.20173 3.20191 0.9375 6 0.9375C8.79827 0.9375 11.0625 3.20191 11.0625 6C11.0625 8.79827 8.79806 11.0625 6 11.0625Z"
              fill="black"
            />
            <path
              d="M6 5.02344C5.74111 5.02344 5.53125 5.2333 5.53125 5.49219V8.51077C5.53125 8.76966 5.74111 8.97952 6 8.97952C6.25889 8.97952 6.46875 8.76964 6.46875 8.51075V5.49219C6.46875 5.2333 6.25889 5.02344 6 5.02344Z"
              fill="black"
            />
            <path
              d="M6 4.44922C6.34949 4.44922 6.63281 4.1659 6.63281 3.81641C6.63281 3.46691 6.34949 3.18359 6 3.18359C5.65051 3.18359 5.36719 3.46691 5.36719 3.81641C5.36719 4.1659 5.65051 4.44922 6 4.44922Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0-1115-6060">
              <rect fill="white" height="12" width="12" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="content__desc">
        The skin scanner uses advanced analysis technology to detect key skin
        concerns such as dark circles, pores, wrinkles, acne, and more. It
        identifies your skin type and delivers personalized insights, along with
        tailored recommendations to support your skincare routine.
      </div>

      <div class="content__buttons">
        <ion-button
          color="main-button"
          fill="solid"
          (click)="letGetStarted(); skinPromptModal.dismiss(null, 'go')"
        >
          Let’s get started!
        </ion-button>
      </div>
    </div>
  </ng-template>
</ion-modal>

<app-health-score-disclaimer [(show)]="modal.disclaimer" />
